
import Service from '@/service/index.js';

// 线上支付
const onlinePayment = ({ }, params) => {
  console.log(params, '====params');
  return new Promise((resove, reject) => {
    // 校验是否开通快捷支付 如果已经开通就跳转到支付页面
    Service.checkOpenQuikPay(params.projectBidCode).then(res => {
      if (res.code === '0') {

        delete params.projectBidCode;

        // amount: params.amount,  // 交易金额
        // bidNo: params.bidNo,    // 标的编号
        // cashierType: 'PC',      // 收银台类型(PC端/移动端)
        // transactionType: 1,     // 2 保证金； 10 合同款、履约保证金；12 工程质保金
        // acctNo                  // 付款方银行账号
        console.log('已开通快捷支付');
        // 跳转到支付页面
        return Service.getJNOrderApply(params).then(res2 => {
          if (res2.code === '0') {
            resove(res2);
          }
        });
      }
    }).catch(error => {
      reject(error);
    });
  });
};
const generatorClickToken = ({ commit }) => {
  return new Promise((resove, reject) => {
    Service.generatorClickToken().then(res => {
      commit('SET_CLICK_TOKEN', res.data);
      resove(res);
    }).catch(error => {
      reject(error);
    });
  });
};

export const actions = {
  onlinePayment,
  generatorClickToken
};
